'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropDownMenu = require('@liveauctioneers/caterwaul-components/lib/dropDownMenu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _FormattedMessage = require('../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _LoggedIn = require('./LoggedIn.scss');

var _LoggedIn2 = _interopRequireDefault(_LoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedIn = function (_Component) {
    (0, _inherits3.default)(LoggedIn, _Component);

    function LoggedIn() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoggedIn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoggedIn.__proto__ || (0, _getPrototypeOf2.default)(LoggedIn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            mobile: _this.props.mobile ? _this.props.mobile === 'phone' : false
        }, _this.shouldComponentUpdate = function (nextProps, nextState) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps) || !(0, _reactFastCompare2.default)(_this.state, nextState);
        }, _this.logOut = function () {
            _this.props.logOutBidder();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LoggedIn, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.windowWidth !== prevProps.windowWidth) {
                if (this.props.windowWidth < 768 && !this.state.mobile) {
                    this.setState({ mobile: true });
                }
                if (this.props.windowWidth >= 768 && this.state.mobile) {
                    this.setState({ mobile: false });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                parent = _props.parent,
                whiteLabel = _props.whiteLabel;
            var mobile = this.state.mobile;


            var links = [];
            links.push((0, _jsx3.default)(_link2.default, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/saved-items'
            }, 'saved-items', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'saved_items'
            })));
            links.push((0, _jsx3.default)(_link2.default, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/my-bids'
            }, 'my-bids', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'my_bids'
            })));
            links.push((0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/dashboard/my-auctions'
            }, 'my-auctions', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'my_auctions'
            })));
            links.push((0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/dashboard/won-items'
            }, 'won-items', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'won_items'
            })));
            links.push((0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/dashboard/messages'
            }, 'messages', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'messages'
            })));
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_link2.default, {
                    route: true,
                    to: '/dashboard/search-and-alerts/'
                }, 'search-and-alerts', (0, _jsx3.default)(_FormattedMessage2.default, {
                    id: 'saved_searches_and_alerts'
                })));
            }
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_link2.default, {
                    route: true,
                    to: '/dashboard/followed-auctioneers'
                }, 'followed-sellers', (0, _jsx3.default)(_FormattedMessage2.default, {
                    id: 'followed_auctioneers'
                })));
            }
            links.push((0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/dashboard/profile'
            }, 'profile', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'account_settings'
            })));
            links.push((0, _jsx3.default)(_link2.default, {
                className: _LoggedIn2.default['log-out'],
                onClick: this.logOut
            }, 'log-out', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'log_out'
            })));

            var title = (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'me'
            });

            return (0, _jsx3.default)('div', {
                className: _LoggedIn2.default['logged-in']
            }, void 0, !mobile && links.splice(0, 2), (0, _jsx3.default)(_dropDownMenu2.default, {
                links: links,
                mobile: this.props.mobile,
                dropdownClass: _LoggedIn2.default['me-button'],
                parent: parent,
                placement: 'bottom',
                popoverClass: _LoggedIn2.default.popover,
                title: title,
                titleClass: _LoggedIn2.default.me
            }));
        }
    }]);
    return LoggedIn;
}(_react.Component);

exports.default = LoggedIn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Login/LoggedIn.js
// module id = g19V
// module chunks = 60